import React, { useContext } from 'react'
import logo1 from "./../../assets/card-logos/amazon-pay.jpg"
import logo2 from "./../../assets/card-logos/american-express.jpg"
import logo3 from "./../../assets/card-logos/masterCard.jpg"
import logo4 from "./../../assets/card-logos/paypal.jpg"
import { CheckOutContext } from '../../Context/CheckOutContext.jsx'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { Helmet, HelmetProvider } from 'react-helmet-async'







const CheckOut = () => {

    const { checkoutFormik } = useContext(CheckOutContext)

    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | Checkout</title>
            </Helmet>
            <div className="container">
                <div className="flex flex-col">
                    <h2 className="text-2xl font-medium my-3 text-center" >Checkout</h2>
                    <form onSubmit={checkoutFormik.handleSubmit} className="form shadow-xl rounded-lg p-4 w-full md:w-3/4 m-auto">
                        <div className="flex flex-col">
                            <label className="text-lg m-1" htmlFor="address">Address <span className="text-red-600">*</span></label>
                            <input onBlur={checkoutFormik.handleBlur}
                                value={checkoutFormik.values.address}
                                onChange={checkoutFormik.handleChange} className="p-2 focus:outline-none border-2 border-slate-300 rounded text-base" name="address" id="address" type="text" />
                            {checkoutFormik.errors.address && checkoutFormik.touched.address ?
                                <div className=" py-1 text-red-600 my-2">{checkoutFormik.errors.address}</div> : ""}
                        </div>
                        <div className="flex flex-col">
                            <label className="text-lg m-1" htmlFor="phone">Phone Number <span className="text-red-600">*</span></label>
                            <input
                                onBlur={checkoutFormik.handleBlur}
                                value={checkoutFormik.values.phone}
                                onChange={checkoutFormik.handleChange} className="p-2 focus:outline-none border-2 border-slate-300 rounded text-base" name="phone" id="phone" type="text" />
                            {checkoutFormik.errors.phone && checkoutFormik.touched.phone ?
                                <div className=" py-1 text-red-600 my-2">{checkoutFormik.errors.phone}</div> : ""}
                        </div>
                        <div className="flex flex-col">
                            <label className="text-lg m-1" htmlFor="coupon">Coupon Code</label>
                            <input
                                onBlur={checkoutFormik.handleBlur}
                                value={checkoutFormik.values.couponCode}
                                onChange={checkoutFormik.handleChange} className="p-2 focus:outline-none border-2 border-slate-300 rounded text-base" name="couponCode" id="coupon" type="text" />
                            {checkoutFormik.errors.couponCode && checkoutFormik.touched.couponCode ?
                                <div className=" py-1 text-red-600 my-2">{checkoutFormik.errors.couponCode}</div> : ""}
                        </div>
                        <div className="flex flex-col sm:flex-row sm:gap-5 my-4">
                            <label className="text-lg m-1" htmlFor="paymentMethod">Payment Method <span className="text-red-600">*</span></label>
                            <FormControl>
                                <InputLabel id="demo-simple-select-label">Method</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label paymentMethod"
                                    id="demo-simple-select"
                                    name="paymentMethod"
                                    onBlur={checkoutFormik.handleBlur}
                                    value={checkoutFormik.values.paymentMethod}
                                    onChange={checkoutFormik.handleChange}
                                    label="Method"
                                    className="text-center text-base w-28"
                                >
                                    <MenuItem value={"cash"}>Cash</MenuItem>
                                    <MenuItem value={"card"}>Card</MenuItem>
                                </Select>
                            </FormControl>
                            {checkoutFormik.errors.paymentMethod && checkoutFormik.touched.paymentMethod ?
                                <div className=" py-1 text-red-600 my-2">{checkoutFormik.errors.paymentMethod}</div> : ""}
                        </div>
                        <div className="flex justify-between flex-col gap-4 w-full md:flex-row items-center">
                            <div className="my-3 flex gap-x-3 w-full md:w-6/12 ">
                                <button type='submit' className="py-2 w-1/2 rounded bg-amber-600 text-slate-50 hover:bg-amber-500 uppercase">Order</button>
                            </div>
                            <div className="logos flex flex-row items-center gap-x-2 md:w-6/12">
                                <div className="">
                                    <img className="w-full" src={logo1} alt="" />
                                </div>
                                <div className="">
                                    <img className="w-full" src={logo2} alt="" />
                                </div>
                                <div className="">
                                    <img className="w-full" src={logo3} alt="" />
                                </div>
                                <div className="">
                                    <img className="w-full" src={logo4} alt="" />
                                </div>
                            </div>
                        </div>
                    </form>
                </div >
            </div >
        </HelmetProvider>
    )
}

export default CheckOut